/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_TitleInputs */

const cs_videos_title = /** @type {(inputs: Videos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videa`)
};

const en_videos_title = /** @type {(inputs: Videos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos`)
};

/**
* | output |
* | --- |
* | "Videos" |
*
* @param {Videos_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_title = /** @type {((inputs?: Videos_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_title(inputs)
	return cs_videos_title(inputs)
});